import styled, { css } from 'styled-components';
import { transparentize, rem } from 'polished';
import { fontSize, boxShadow, transition } from '../../mixins';
export var CommStyles = function CommStyles() {
  return css(["display:", ";vertical-align:bottom;font-family:", ";", ";text-decoration:underline;border-radius:", ";cursor:pointer;", ";", ";", ";"], function (_ref) {
    var iconInline = _ref.iconInline;
    return iconInline ? 'inline' : 'inline-flex';
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.font.family.primary;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return fontSize(theme.font.size.xs);
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.radius;
  }, transition, colorStyle, standaloneStyle);
};
export var StyledAnchor = styled.a.withConfig({
  displayName: "Linkstyle__StyledAnchor",
  componentId: "sc-124xyde-0"
})(["", ";"], CommStyles);

function colourContrast(props) {
  var theme = props.theme;
  return "\n      @media (forced-colors: active) and (prefers-color-scheme: light) {\n        && {\n          color: ".concat(theme.color.black, ";\n        }\n        &:hover,\n        &:focus \n        {\n          color: ").concat(theme.color.black, "\n        }\n      }\n      @media (forced-colors: active) and (prefers-color-scheme: dark) {\n        && {\n          color: ").concat(theme.color.white, ";\n        }\n        &:hover,\n        &:focus\n        {\n          color: ").concat(theme.color.white, "\n        }\n      }\n    ");
}

export var StyledIconSpan = styled.span.withConfig({
  displayName: "Linkstyle__StyledIconSpan",
  componentId: "sc-124xyde-1"
})(["display:inline-flex;margin-right:", ";", ";", ";svg{color:", ";", ";", ";}"], function (_ref5) {
  var iconInline = _ref5.iconInline;
  return iconInline ? rem('2px') : 0;
}, function (_ref6) {
  var iconInline = _ref6.iconInline;
  return (iconInline ? 'padding-left' : 'padding-right') + ": ".concat(rem('4px'));
}, function (_ref7) {
  var iconInline = _ref7.iconInline;
  return iconInline ? "transform:translateY(25%)" : '';
}, function (_ref8) {
  var theme = _ref8.theme,
      tint = _ref8.tint;
  return theme.color[tint];
}, transition, colourContrast);
export function colorStyle(props) {
  var theme = props.theme;
  var tint = props.$isOnDarkBg ? 'white' : props.tint;
  var colorMap = {
    black: theme.color.primary,
    primary: theme.color.black,
    error: theme.color.black,
    sapphire: theme.color.black,
    white: theme.color.grey50
  };
  var baseColor = theme.color[tint];
  var stateColor = colorMap[tint];
  return "\n    color: ".concat(baseColor, ";\n    svg {\n      color: ").concat(baseColor, ";\n    }\n    @media (forced-colors: active) and (prefers-color-scheme: light) {\n      && {\n        color: ").concat(theme.color.black, ";\n      }\n      &:active,\n      &:focus,\n      &:hover {\n        color: ").concat(theme.color.black, ";\n        svg {\n          color: ").concat(theme.color.black, " !important;\n        }\n      }\n    }\n\n    @media (forced-colors: active) and (prefers-color-scheme: dark) {\n      && {\n        color: ").concat(theme.color.white, ";\n      }\n      &:active,\n      &:focus,\n      &:hover {\n        color: ").concat(theme.color.white, ";\n        svg {\n          color: ").concat(theme.color.white, " !important;\n        }\n      }\n      &:hover {\n        text-decoration: none;\n      }\n    }\n    &:hover {\n      text-decoration-color: transparent; \n      color: ").concat(stateColor, ";\n      svg {\n        color: ").concat(stateColor, ";\n      }\n    }\n    &:focus {\n      text-decoration: underline;\n      color: ").concat(baseColor, ";\n      svg {\n        color: ").concat(baseColor, ";\n      }\n    }\n    ").concat(boxShadow(baseColor, 'focus'), ";\n    &:active {\n      color: ").concat(stateColor, ";\n      box-shadow : 0 0 0 3px ").concat(transparentize(0.35, props.$isOnDarkBg ? baseColor : stateColor), ";\n      text-decoration-color: transparent;\n      svg {\n        color: ").concat(stateColor, ";\n      }\n    }\n  ");
}

function standaloneStyle(_ref9) {
  var theme = _ref9.theme,
      standalonelink = _ref9.standalonelink;
  return standalonelink && "\n      padding-top: ".concat(rem('12px'), ";\n      padding-bottom: ").concat(rem('12px'), ";\n      min-height: ").concat(theme.spaces.xxlg, ";\n    ");
}